import { GetServerSideProps } from 'next'
import { SEOHead } from '~/components/business/SEOHead'
import { GlobalRequest } from '~/components/global-request'
import { CompetitionDataInfo } from '~/components/pages/ai-competition/ai-competition-detail/CompetitionDataInfo'
import {
  CompetitionHeader,
  formatBannerRes,
} from '~/components/pages/ai-competition/ai-competition-detail/CompetitionHeader'
import { CompetitionTabs } from '~/components/pages/ai-competition/ai-competition-detail/CompetitionTabs'
import { MyContainer } from '~/components/ui/MyContainer'
import {
  GET_AI_COMPETITION_RESULT_LIST,
  GET_COMPETITION_DETAIL,
  GET_COMPETITION_NEWS,
} from '~/graphqls/gqls'
import {
  IAICompetitionDetail,
  getAiCompetitionResultList,
  getAiCompetitionResultListVariables,
  getAiCompetitionResultList_marketingModule_competitionResult,
  getCompetitionDetail,
  getCompetitionDetailVariables,
  getCompetitionNews,
  getCompetitionNewsVariables,
  getCompetitionNews_marketingModule_competitionNewsPo,
} from '~/graphqls/types'

import { Layout } from '~/layouts/default'

export const CompetitionLayout: React.FC<{
  banner: IAICompetitionDetail
  competitionResultList: getAiCompetitionResultList_marketingModule_competitionResult[]
  competitionNews: getCompetitionNews_marketingModule_competitionNewsPo[]
  children: React.ReactNode
}> = ({ banner, competitionResultList, competitionNews, children }) => {
  return (
    <Layout>
      <SEOHead title={banner.name} />
      <MyContainer>
        <CompetitionHeader banner={banner} />
        {!!banner?.host_list && (
          <CompetitionDataInfo host={banner?.host_list} className="mt-10" />
        )}
        <CompetitionTabs
          banner={banner}
          competitionResultList={competitionResultList}
          competitionNews={competitionNews}
        />
        {children}
      </MyContainer>
    </Layout>
  )
}

export const genGetServerSideProps = () => {
  const getServerSideProps: GetServerSideProps = async context => {
    const { client, initialState } = await GlobalRequest(context)
    const competitionId = Number(context.params?.id)

    if (Number.isNaN(competitionId)) {
      return {
        notFound: true,
      }
    }

    const bannerRes = await client.query<
      getCompetitionDetail,
      getCompetitionDetailVariables
    >({
      query: GET_COMPETITION_DETAIL,
      variables: {
        id: competitionId,
      },
      fetchPolicy: 'no-cache',
    })

    const [competitionResultListRes, competitionNewsRes] = await Promise.all([
      client.query<
        getAiCompetitionResultList,
        getAiCompetitionResultListVariables
      >({
        query: GET_AI_COMPETITION_RESULT_LIST,
        variables: {
          id: competitionId,
        },
        fetchPolicy: 'no-cache',
      }),
      client.query<getCompetitionNews, getCompetitionNewsVariables>({
        query: GET_COMPETITION_NEWS,
        variables: {
          id: competitionId,
        },
        fetchPolicy: 'no-cache',
      }),
    ])

    return {
      props: {
        initialState,
        banner: formatBannerRes(bannerRes?.data?.marketingModule?.competition),
        competitionResultList:
          competitionResultListRes?.data?.marketingModule?.competitionResult?.filter(
            it => !!it?.leveLValue && !!it?.leveL
          ) || [],
        competitionNews:
          competitionNewsRes?.data?.marketingModule?.competitionNewsPo || [],
      },
    }
  }

  return getServerSideProps
}
